// Deterministic cartoon avatar (DiceBear) used as the fallback when a user has
// no photo — matches the avatar generated for users at signup (auth.ts).
export function dicebearUrl(seed: string): string {
  return `https://api.dicebear.com/9.x/adventurer/svg?seed=${encodeURIComponent(
    seed || 'goaltree',
  )}&backgroundColor=a8ff3e,b6e3f4,c0aede,d1d4f9,ffd5dc,ffdfbf`
}
